// hooks/useFormData.js
import { useState, useEffect } from "react";
import axios from "axios";

const useFormData = (formId, responseId) => {
  const [formStructure, setFormStructure] = useState(null);
  const [responseData, setResponseData] = useState(null);
  const [responseStatus, setResponseStatus] = useState(null);
  const [responseRequestedTo, setResponseRequestedTo] = useState(null);
  const [responseRequestedToName, setResponseRequestedToName] = useState(null);
  const [responseRequestedBy, setResponseRequestedBy] = useState(null);
  const [responseUserId, setResponseUserId] = useState(null);
  const [siteId, setSiteId] = useState(null);
  const [formType, setFormType] = useState(null);
  const [signatures, setSignatures] = useState([]);
  const [requiredDocuments, setRequiredDocuments] = useState([]);
  const [error, setError] = useState(null);
  const API_BASE_URL = "https://formbuilderapi.getforsite.com"; //process.env.REACT_APP_API_URL ||
  useEffect(() => {
    const fetchData = async () => {
      try {
        const formResponse = await axios.get(
          `${API_BASE_URL}/api/forms/${formId}`,
        );
        setFormStructure(formResponse.data.formStructure);
        setRequiredDocuments(formResponse.data.requiredDocuments || []);
        setSiteId(formResponse.data.site_id);
        setFormType(formResponse.data.formStructure.formType);

        const response = await axios.get(
          `${API_BASE_URL}/api/forms/${formId}/responses/${responseId}`,
        );
        setResponseData(response.data.responseData);
        setResponseStatus(response.data.status);
        setResponseUserId(response.data.user_id);
        setResponseRequestedBy(response.data.requested_by);

        setResponseRequestedTo(response.data.requested_to);
        setResponseRequestedToName(response.data.requested_to_name);

        if (
          response.data.signatures &&
          Array.isArray(response.data.signatures)
        ) {
          setSignatures(response.data.signatures);
        }
      } catch (err) {
        console.error("Error fetching form data:", err);
        setError(err);
      }
    };

    fetchData();
  }, [formId, responseId, API_BASE_URL]);

  return {
    formStructure,
    responseData,
    setResponseData,
    responseStatus,
    responseUserId,
    responseRequestedTo,
    responseRequestedToName,
    responseRequestedBy,
    setResponseStatus,
    siteId,
    formType,
    signatures,
    setSignatures,
    requiredDocuments,
    error,
  };
};

export default useFormData;
